import * as React from 'react'

function SvgIconDocumentLegal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="document-legal"
        aria-labelledby="t-document-legal d-document-legal"
      >
        <title id="t-document-legal">{'Legal document'}</title>
        <desc id="d-document-legal">
          {'Legal contract written in a paper sheet with a trust label'}
        </desc>
        <path d="M19 1.4L25.6 8H19V1.4zM27 32V8l-8-8H5v32h4v-1H6V1h12v7c0 .6.4 1 1 1h7v22H15v1h12z" />
        <path d="M8 7h6v1H8V7zm2 4h14v1H10v-1zm-2 4h16v1H8v-1zm0 4h12v1H8v-1zm11 8h4v1h-4v-1zm0-4h4v1h-4v-1zm-7-1c-1.7 0-3 1.3-3 3 0 .9.4 1.7 1 2.2V31c0 .4.2.8.6.9.1.1.3.1.4.1.3 0 .5-.1.7-.3l.3-.3.3.3c.2.2.4.3.7.3.1 0 .3 0 .4-.1.4-.2.6-.5.6-.9v-3.8c.6-.5 1-1.3 1-2.2 0-1.7-1.3-3-3-3zm1 9l-1-1-1 1v-3.2c.3.101.6.2 1 .2s.7-.1 1-.2V31zm-1-4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
      </g>
    </svg>
  )
}

export default SvgIconDocumentLegal
